import { SwipeAxis } from './Swipe.model';

export const calculateOffset = (x: number, y: number, direction: SwipeAxis): number => {
  if (direction === 'x') {
    return Math.abs(x);
  }
  if (direction === 'y') {
    return Math.abs(y);
  }
  return Math.hypot(x, y);
};
